module.exports = __webpack_public_path__ + "img/SummaryBanner.58865ec7.png";